import * as url from '../../../helpers/url_helper';
import { post } from '../../../helpers/api_helper';

export const resetPasswordAPI = data => {
	return post(url.POST_RESET_PASSWORD, data);
};

export const changeThemeDataAPI = data => {
	return post(url.POST_CHANGE_THEMEDATA, data);
};
